import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
    direction: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CardArrow',
  props: {
    direction: {}
  },
  emits: ['scroll-left', 'scroll-right'],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const emitChange = (): void => {
    if (props.direction === 'left')
        emit('scroll-left');
    else if (props.direction === 'right') 
        emit('scroll-right');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-arrow", props.direction]),
    onClick: emitChange
  }, "⌃", 2))
}
}

})